import React from 'react';
import styled from 'styled-components';
import ScrollItem from './ScrollItem';
const TableOuter = styled.div`
                        height:270px;
                        overflow-y:scroll;
                        padding: 0px 20px;

                        .status {
                            width: 20px;
                            height: 20px;
                            border-radius: 20px;
                        }

                        table{
                           
                            border-collapse: collapse;
                            width:100%; 

                            tr{
                                border-bottom:solid 1px #c2cbd4;

                                th, td{
                                    font-size:14px;
                                    font-weight:normal;
                                    text-align:left;
                                    padding: 10px 0;
                                }
                                .full-width{
                                    width:100%;
                                    color:#fff;
                                    text-align:center;
                                    font-weight:bold;
                                    text-transform:uppercase;
                                    background:blue;
                                }
                                &:hover{
                                    cursor:pointer;
                                }
                            }    
                            .owner{
                                font-weight:bold;
                                color:#0084fe;
                            }                        
                        }

                        /* width */
                        ::-webkit-scrollbar {
                            width: 10px;
                        }

                        /* Track */
                        ::-webkit-scrollbar-track {
                            background: #ffffff;
                            border-radius: 10px;
                        }

                        /* Handle */
                        ::-webkit-scrollbar-thumb {
                            background: #989798;
                            border-radius: 10px;
                        }

                        /* Handle on hover */
                        ::-webkit-scrollbar-thumb:hover {
                            background: #555;
                        }
`

const ScrollTable = (props) => {

    return (
        <TableOuter>
            <table>
                <tbody>
                    <tr>
                        <th>Due date</th>
                        <th>Task</th>
                        <th>Owner</th>
                        <th>Status</th>
                    </tr>
                    {props.departments && props.item ? props.departments.map((department, index) =>
                        <React.Fragment key={index}>
                            {props.deliverables.filter(deliverable => (deliverable.dept === department.slug) && (deliverable.objective === props.item.key)).length !== 0 ?
                                <tr><td className="full-width" colSpan="4" style={{ background: department.color }}>{department.name}</td></tr>
                                : ''}
                            {props.deliverables.filter(deliverable => (deliverable.dept === department.slug) && (deliverable.objective === props.item.key)).map((deliverable, index) => (
                                <ScrollItem activity={deliverable} key={index} deliverable={true} />
                            ))
                            }
                        </React.Fragment>
                    )
                        : props.activities.map((activity, index) => (
                            <ScrollItem activity={activity} key={index} deliverable={false} />
                        ))
                    }

                </tbody>
            </table>
        </TableOuter>

    )
}

export default ScrollTable;